import loadable from '@loadable/component';

export const SearchHeroLoadable = loadable(() => import('./SearchHero'), {
  resolveComponent: (module) => module.SearchHero,
});
